import EditOrder from 'containers/EditOrder/entry';

import { isQuotingToolAvailable } from 'modules/common/permissions';

import { OrdersListPage } from './listPage';

export const ordersBaseRoute = '/orders';

export const routes = [
  {
    path: `${ordersBaseRoute}/edit/:orderNumber`,
    component: EditOrder,
    helpId: 'order_details',
    permissions: [isQuotingToolAvailable],
  },
  {
    path: ordersBaseRoute,
    component: OrdersListPage,
    helpId: 'orders_list',
    permissions: [isQuotingToolAvailable],
  },
];
